export function redirectToDownloadEndpoint(pdfDownloadEndpoint) {
  window.location.assign(pdfDownloadEndpoint);
}
